export interface TsManagerRatingType {

}

export enum TsManagerRatingTypeEnum {
  EVERYDAY = 'everyday',
  OVERALL = 'overall'
}
